import { Controller } from "@hotwired/stimulus";

  /* 
    Handle the problem of redirects from within a modal.
    If the form response has some errors, we want to display the content within
    the modal frame.

    However, on success there will be a redirect. The redirect should trigger a full page
    navigation, breaking out of the turbo frame.
  */

export default class extends Controller {

  handleSubmitEnd(event) {

    console.log("Handling form submission: ", event);

    const { detail } = event;
    const { fetchResponse } = detail;

    if (!fetchResponse) return; // No response to handle

    // If the response is a redirect, perform a full-page visit
    if (fetchResponse.redirected) {
      console.log("Redirecting");
      Turbo.visit(fetchResponse.response.url);
      // await this.visitResponse(fetchResponse);
    }
    // Otherwise, let Turbo handle the response within the frame
  }

  // async visitResponse(response) {
  //   const wrapped = new FetchResponse(response);
  //   const responseHTML = await wrapped.responseHTML;
  //   const { location, redirected, statusCode } = wrapped;

  //   return Turbo.session.visit(location, { response: { redirected, statusCode, responseHTML } });
  // }


}
